import React from "react";
import ReactDOM from "react-dom/client";
import { MemoryRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

import { ThemeProvider } from "styled-components";
import { DIGIPOSTHEME } from "./theme/digiPosTheme";
import { MediaQueryProvider } from "context/media/MediaContext";

import { I18nextProvider } from "react-i18next";
import { LangProvider } from "context/locale/LangContext";
import i18n from "localization/i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={DIGIPOSTHEME}>
      <MediaQueryProvider>
        <I18nextProvider i18n={i18n}>
          <LangProvider>
            <Provider store={store}>
              <MemoryRouter>
                <App />
              </MemoryRouter>
            </Provider>
          </LangProvider>
        </I18nextProvider>
      </MediaQueryProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
